module.exports = __webpack_public_path__ + "img/arrow-left.48fc732e.svg";